import { useMemo } from "react";
import { useAutoAnimate as useFormkitAutoAnimate } from "@formkit/auto-animate/react";
import type { AutoAnimateOptions } from "@formkit/auto-animate";

const DEFAULT_OPTIONS: AutoAnimateOptions = {
  duration: 220,
  easing: "ease-in-out",
};

export function useUiAutoAnimate(options?: Partial<AutoAnimateOptions>) {
  const merged = useMemo(
    () => ({ ...DEFAULT_OPTIONS, ...(options ?? {}) }),
    [options],
  );
  const [parent] = useFormkitAutoAnimate(merged);
  return parent;
}
